/**
 * ¿Título de portal / scraping (Idealista, Fotocasa, Habitaclia, Pisos…)?
 * Misma espíritu que backend captacionTextosWeb.esTituloDePortalScraping.
 * Aplica a TODOS los portales. No usar como título CRM / web.
 */
export function decodeHtmlEntitiesBasico(s) {
  return String(s || "")
    .replace(/&#(\d+);/g, (_, n) => {
      try { return String.fromCharCode(Number(n)); } catch { return ""; }
    })
    .replace(/&#x([0-9a-f]+);/gi, (_, h) => {
      try { return String.fromCharCode(parseInt(h, 16)); } catch { return ""; }
    })
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");
}

export function esTituloDePortalScraping(titulo, extras = {}) {
  const raw = String(titulo || "").trim();
  if (!raw) return false;

  const portalGuardado = String(extras?.titulo_portal || "").trim();
  if (portalGuardado) {
    const a = decodeHtmlEntitiesBasico(raw).toLowerCase().replace(/\s+/g, " ");
    const b = decodeHtmlEntitiesBasico(portalGuardado).toLowerCase().replace(/\s+/g, " ");
    if (a && b && (a === b || a.includes(b) || b.includes(a))) return true;
  }

  if (/&#\w+;/.test(raw)) return true;

  const s = decodeHtmlEntitiesBasico(raw);

  if (/\b(idealista|fotocasa|habitaclia|pisos\.com|yaencontre)\b/i.test(s)) return true;
  if (/\|\s*(idealista|fotocasa|habitaclia|pisos)/i.test(s)) return true;

  if (/\ben\s+(venta|alquiler|compra)\s+en\b/i.test(s)) return true;
  if (/\bpor\s+[\d.]{3,}\s*€?/i.test(s)) return true;

  const via =
    "Calle|C\\/|Cl\\.?|Avda\\.?|Av\\.?|Avenida|Avinguda|Camino|Cam[ií]|Plaza|Plaça|"
    + "Partida|Pd\\.?|Urbanizaci[oó]n|Carrer|Paseo|Passeig|Carretera|Ctra\\.?|"
    + "Rambla|Ronda|Traves[ií]a|Travessera|Rua|Rúa";
  if (new RegExp(`\\b(?:${via})\\b.{0,80}?\\d`, "i").test(s)) return true;

  if (/,\s*\d{1,4}\s*,\s*[A-Za-zÁÉÍÓÚáéíóúñÑ]/.test(s)) return true;

  if (/\b(con\s+(gran\s+)?terraza|piscina\s+y\s+parking)\b.+\ben\s+/i.test(s) && s.length > 60) {
    return true;
  }

  return false;
}

/** Título usable en CRM/web: vacío o estilo «Piso en Orba», no portal. */
export function tituloCrmUsable(titulo, extras = {}) {
  const t = String(titulo || "").trim();
  if (!t) return "";
  if (esTituloDePortalScraping(t, extras)) return "";
  if (/\ben\s+\d{4,5}\b/i.test(t)) return "";
  return t;
}

const UUID_RX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Tipología de portal («Casa o chalet independiente», «Chalet adosado»), no nombre CRM. */
export function esTipoInmuebleDePortal(tipo) {
  const t = String(tipo || "").trim();
  if (!t) return false;
  if (UUID_RX.test(t)) return false;
  if (t.length > 40) return true;
  if (/\bo\b/i.test(t)) return true;
  if (/\ben\s+(venta|alquiler)\b/i.test(t)) return true;
  if (/\badosad[oa]\b/i.test(t)) return true;
  if (/independiente/i.test(t) && t.length > 20) return true;
  return false;
}

/** Portal → catálogo CRM (wizard / select). Vacío si no hay equivalencia. */
export function mapTipoPortalACrm(tipoPortal) {
  const t = String(tipoPortal || "").trim().toLowerCase();
  if (!t) return "";
  const exact = {
    "chalet adosado": "Pareado",
    "casa adosada": "Pareado",
    "adosado": "Pareado",
    "casa o chalet independiente": "Chalet",
    "casa o chalet": "Chalet",
    "piso o apartamento": "Piso",
  };
  if (exact[t]) return exact[t];
  if (/\badosad/.test(t)) return "Pareado";
  if (/independiente/.test(t) && /(chalet|casa)/.test(t)) return "Chalet";
  if (/\bpiso\b/.test(t) && /\bapartamento\b/.test(t)) return "Piso";
  return "";
}

export function tipoCrmUsable(tipo) {
  const t = String(tipo || "").trim();
  if (!t) return "";
  if (esTipoInmuebleDePortal(t)) return mapTipoPortalACrm(t);
  return t;
}

function normPortal(s) {
  return String(s || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");
}

/** Diccionarios espejo backend mapPortalCamposACrm (sinónimos portal → CRM). */
const MAP_ESTADO = {
  "a reformar": "Para reformar",
  "para reformar": "Para reformar",
  "en ruinas": "Para reformar",
  "buen estado": "Buen estado",
  bueno: "Buen estado",
  "muy bueno": "Buen estado",
  normal: "Buen estado",
  "obra nueva": "Obra nueva",
  nuevo: "Obra nueva",
  "casi nuevo": "Casi nuevo",
  reformado: "Reformado",
};
const MAP_CALEFACCION = {
  splits: "Splits",
  split: "Splits",
  conductos: "Conductos",
  electrica: "Eléctrica",
  eléctrica: "Eléctrica",
  gas: "Gas",
  "gas natural": "Gas",
  central: "Central",
  "no tiene": "No tiene",
};
const MAP_COCINA = {
  americana: "Americana",
  independiente: "Independiente",
  office: "Office",
  amueblada: "Amueblada",
  "no amueblada": "No amueblada",
};
const MAP_PISCINA = {
  privada: "Privada",
  particular: "Privada",
  comunitaria: "Comunitaria",
  comun: "Comunitaria",
  común: "Comunitaria",
  normal: "Normal",
};
const MAP_ORIENTACION = {
  norte: "Norte",
  sur: "Sur",
  este: "Este",
  oeste: "Oeste",
  nordeste: "Nordeste",
  noreste: "Nordeste",
  sudeste: "Sudeste",
  sureste: "Sudeste",
  noroeste: "Noroeste",
  suroeste: "Suroeste",
  sudoeste: "Suroeste",
};

function mapConDiccionario(raw, dicc) {
  const n = normPortal(raw);
  if (!n) return "";
  if (dicc[n]) return dicc[n];
  for (const [k, v] of Object.entries(dicc)) {
    if (k.length >= 4 && (n.includes(k) || k.includes(n))) return v;
  }
  return "";
}

/** Portal → CRM o vacío (nunca dejar literal portal en clave CRM). */
export function estadoCrmUsable(raw) {
  const t = String(raw || "").trim();
  if (!t) return "";
  return mapConDiccionario(t, MAP_ESTADO) || (/^(obra nueva|buen estado|para reformar|casi nuevo|reformado|a estrenar)$/i.test(t) ? t : "");
}
export function calefaccionCrmUsable(raw) {
  const t = String(raw || "").trim();
  if (!t) return "";
  return mapConDiccionario(t, MAP_CALEFACCION);
}
export function cocinaCrmUsable(raw) {
  const t = String(raw || "").trim();
  if (!t) return "";
  return mapConDiccionario(t, MAP_COCINA) || (/^(americana|independiente|office|amueblada)$/i.test(t) ? t : "");
}
export function piscinaCrmUsable(raw) {
  const t = String(raw || "").trim();
  if (!t) return "";
  return mapConDiccionario(t, MAP_PISCINA);
}
export function orientacionCrmUsable(raw) {
  const first = String(raw || "").split(/[,/;|]/)[0].trim();
  if (!first) return "";
  return mapConDiccionario(first, MAP_ORIENTACION) || (/^(norte|sur|este|oeste|nordeste|sudeste|noroeste|suroeste)$/i.test(first) ? first.charAt(0).toUpperCase() + first.slice(1).toLowerCase() : "");
}
